import { render, staticRenderFns } from "./move.vue?vue&type=template&id=369ef198&scoped=true"
import script from "./move.vue?vue&type=script&lang=js"
export * from "./move.vue?vue&type=script&lang=js"
import style0 from "./move.vue?vue&type=style&index=0&id=369ef198&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369ef198",
  null
  
)

export default component.exports